import { Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Onboarding.MerchantOrCustomerDescription;

export const MerchantOrCustomerDescription = () => {
  const { t } = useResource();

  return (
    <Stack gap={2} sx={{ "& strong": { fontWeight: 500, mr: 1 } }}>
      <Typography variant="h6">{t(COMPONENT_RESOURCES.Welcome)}</Typography>
      <Typography>
        {t(COMPONENT_RESOURCES.IdentityVerificationRequired)}
      </Typography>
      <Typography>
        <Typography component="strong">
          {t(COMPONENT_RESOURCES.MoonePaymentIdentity)}
        </Typography>
        {t(COMPONENT_RESOURCES.PaymentIdentityDescription)}
      </Typography>
      <Typography>
        {t(COMPONENT_RESOURCES.LicensedPaymentInstitution)}
        <Typography component="strong" sx={{ ml: 1 }}>
          {t(COMPONENT_RESOURCES.BankLevelIdentityVerification)}
        </Typography>
      </Typography>
      <Typography>{t(COMPONENT_RESOURCES.DocumentsUsagePurpose)}</Typography>
      <Typography>
        <Typography component="strong">
          {t(COMPONENT_RESOURCES.QuickProcessAndThankYou)}
        </Typography>
      </Typography>
    </Stack>
  );
};
